// React / Next
import { createFileRoute } from '@tanstack/react-router';

// Components
import { SecurityAddendumPage } from '../pages/SecurityAddendumPage/SecurityAddendumPage';

export const Route = createFileRoute('/security-addendum')({
  component: SecurityAddendumPage,
});
